(() => {
  if (window.__heCartCroLoaded) return;
  window.__heCartCroLoaded = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-he-upgrade], [data-he-cart-upsell]');
    if (!button || button.disabled) return;
    button.disabled = true;
    const originalLabel = button.textContent;
    const isCrossSell = button.hasAttribute('data-he-cart-upsell');
    button.textContent = isCrossSell ? 'Agregando…' : 'Actualizando…';

    try {
      const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      if (!isCrossSell) {
        const removeResponse = await fetch('/cart/change.js', {
          method: 'POST', headers, body: JSON.stringify({ id: button.dataset.lineKey, quantity: 0 })
        });
        if (!removeResponse.ok) throw new Error('No se pudo retirar la presentación anterior.');
      }
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST', headers, body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
      });
      if (!addResponse.ok) throw new Error(isCrossSell ? 'No se pudo agregar este producto.' : 'No se pudo agregar el paquete de 3 cajas.');
      window.location.reload();
    } catch (error) {
      button.disabled = false;
      button.textContent = originalLabel;
      window.alert(error.message || 'No pudimos actualizar tu carrito. Inténtalo de nuevo.');
    }
  });
})();
